import {getAbsoluteUrl} from "../../utils/urlUtill";
import {AccessLevelToggle} from "./AccessLevelToggle";
import {UserAccessRole} from "./UserAccessRole";

export enum UserGender {
    MALE = "MALE", FEMALE = "FEMALE", UNKNOWN = 'UNKNOWN'
}

export enum LqbUpdateStatus {
    CREATED_NEW = "CREATED_NEW", UPDATED_EXISTING = "UPDATED_EXISTING", EQUALS_EXISTING = "EQUALS_EXISTING"
}

export interface LqbUpdateDTO {
    status: LqbUpdateStatus;
    updatedAccount: LqbUpdateUserDTO;
}

export interface LqbUpdateUserDTO {
    firstName: string;
    lastName: string;
}

export interface User {
    id: number;
    name: string;
    firstName: string;
    lastName: string;

}

export interface UserDto {
    id?: number;
    senderId?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    title?: string;
    email?: string;
    isDeleted?: boolean;
    phone?: string;
    workingPhone?: string;
    isOnline?: boolean;
    featureAccessLevel?: AccessLevelToggle[],
    accessLevel?: UserAccessRole,
    password?: string;
    gender?: UserGender;
    avatarId?: number;
    hasAvatar?: boolean;
    branch?: string;
    isActive?: boolean;
    agentLicenseNumber?: string;
    applyWithMe?: string;
    reviewMe?: string;
    position?: string;
    avatarUrl?: string;
    subscriptionConfig?: UserSubscriptions;
    isLicensed?: boolean;
    isSuperAdmin?: boolean;
    userType?: string;
    canBeEditedByLoggedInUser?: boolean;
    canBeMorphedInto?: boolean;
}

export interface UserSubscriptions {
    isSubscribedToTheDailyOpportunityEmails?: boolean;
    isSubscribedToTheExperianOpportunityRealTimeEmails?: boolean;
    isSubscribedToTheExperianOpportunityRealTimeSms?: boolean;
}

export interface UserGuiDto extends UserDto {
    name?: string;
}

export function convertUserToUserGuiDto(users: UserDto[]): UserGuiDto[] {
    users.forEach(e => {
        let userGui: UserGuiDto = <UserGuiDto>e;
        userGui.avatarUrl = e.avatarUrl ? e.avatarUrl : getDefaultAvatarUrl(e.gender);
        userGui.name = e.firstName + " " + e.lastName;
    });
    return users;
}


export function getAvatarUrl(avatarId: number) {
    return avatarId != null ? getAbsoluteUrl(`api/image/${avatarId}`) : getDefaultAvatarUrl();
}

export function getUserAvatarUrl(avatarId: number) {
    return avatarId != null ? getAbsoluteUrl(`api/user/${avatarId}/image`) : getDefaultAvatarUrl();
}


export function getDefaultAvatarUrl(gender?: UserGender) {
    if (gender == null) {
        return '/app/images/avatar/default_customer.jpg'
    }
    switch (gender) {
        case UserGender.FEMALE:
            return '/app/images/avatar/default_Female.jpg'
        case UserGender.MALE:
            return '/app/images/avatar/default_Male.jpg';
    }
    return '/app/images/avatar/default_customer.jpg';
}
